import React, { useState } from 'react';
import { registerUser } from '../../Services/authService';
import { Link, useNavigate } from 'react-router-dom';

const Register = () => {
    const [form, setForm] = useState({
        id: 0,
        name: '',
        email: '',
        passwordHash: '',
        roleId: 8, // Customer
        isActive: false,
        lastLogin: new Date().toISOString(),
        role: {
            id: 0,
            name: "",
            createdBy: 0
        }
    });

    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

      

            try {
                const res = await registerUser(form);

                // 🔥 CHECK RESPONSE MESSAGE
                if (res === "Email already registered") {
                    setError(res);
                    return;
                }

                if (res === "OTP Sent Successfully" || res === "OTP Sent") {
                    localStorage.setItem("otpEmail", form.email);
                    navigate('/verify-otp');
                } else {
                    setError(res);
                }

            } catch (err) {
                console.error(err);
                setError("Registration failed");
            }
    
    };

    return (
        <div className="auth-fluid">
            {/*Auth fluid left content */}
            <div className="auth-fluid-form-box">
                <div className="card-body d-flex flex-column h-100 gap-3">
                    {/* Logo */}
                    <div className="auth-brand text-center text-lg-start">
                        <Link to="/" className="logo-dark">
                            <span><img src="assets/images/logo-dark.png" alt="dark logo" height={42} /></span>
                        </Link>
                        <a href="index.html" className="logo-light">
                            <span><img src="assets/images/logo.png" alt="logo" height={42} /></span>
                        </a>
                    </div>
                    <div className="my-auto">
                        {/* title*/}
                        <h4 className="mt-0">Sign Up</h4>
                        <p className="text-muted mb-4">Enter your details to register account.</p>
                        {error && <p style={{ color: 'red' }}>{error}</p>}

                        <form onSubmit={handleSubmit}>
                            <input className="form-control mb-2"
                                placeholder="Name"
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                            />

                            <input className="form-control mb-2"
                            type="email"
                                placeholder="Email"
                                onChange={(e) => setForm({ ...form, email: e.target.value })}
                            />

                            <input className="form-control mb-2"
                                type="password"
                                placeholder="Password"
                                onChange={(e) => setForm({ ...form, passwordHash: e.target.value })}
                            />

                            <button className="btn btn-primary w-100">Register</button>
                        </form>

                    </div>
                    {/* Footer*/}
                    <footer className="footer footer-alt">
                        <p className="text-muted">Already have an account? <Link to="/login" className="text-muted ms-1"><b>Sign in</b></Link></p>
                    </footer>
                </div> {/* end .card-body */}
            </div>
            {/* end auth-fluid-form-box*/}
            {/* Auth fluid right content */}
            <div className="auth-fluid-right text-center">

            </div>
            {/* end Auth fluid right content */}
        </div>

    );
};

export default Register;